import { Suspense, lazy } from 'react';

const DefaultFont = lazy(() => import("./default/DefaultFont"));
const CignaFont = lazy(() => import("./cigna/CignaFont"));

const FontSelector = ({ theme, children }) => {
    const renderFont = () => {
        switch (theme) {
            case 'cigna':
                return <CignaFont />          
            case 'bcptn':
            case 'versum':
                return <DefaultFont />
            default:
                return <DefaultFont />
        }
    }

    return (
        <>
            <Suspense fallback={null}>
                {renderFont()}
            </Suspense>
            {children}
        </>
    )
}

export default FontSelector;
